import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import 'rxjs/add/operator/map';

@Injectable()
export class AreasService {

  constructor(private http:HttpClient) {
   }

   getAll(){
     let url = GLOBAL.url+`areas`;
     return this.http.get(url).map(res =>{
       return res;
     });
   }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/areas.service.ts